export enum EInvoiceDetailsTab {
  OVERVIEW = 'overview',
  BILLING_ITEMS = 'billing-items',
  PAYMENT_SCHEDULE = 'payment-schedule',
  INSURED_RISK_OBJECTS = 'insured-risk-objects',
  ADJUSTMENTS = 'adjustments',
  DOCUMENTS = 'documents',
  ACTION_LOG = 'action-log',
}

export interface IInvoiceDetailsTab {
  id: EInvoiceDetailsTab;
  labelKey: string;
  label?: string | null;
}
